export default "__VITE_ASSET__BFx3jRYw__"